import { once } from 'lodash'
import { lifecycle } from 'recompose'
import { dispatchEvent } from '../helpers/tagManager'

const withEventOnceOnMount = (...args) => {
  const track = once(() => dispatchEvent(...args))

  return lifecycle({
    componentDidMount() {
      track()
    },
  })
}

export default withEventOnceOnMount
